import { DATA_METRICS } from '../componentKeys.js'

const identifiers = {
  key: 'talkTime',
  type: 'call',
  access: 'stats',
}

const formatting = {
  format: {
    title: 'Talk Time',
    append: '/hr',
  },
}

const keys = {
  statKey: 'talk_time',
  componentKeys: [DATA_METRICS],
  healthKey: 'metric_health',
}

const calculation = {
  calcType: 'aggregate',
  convertTo: 'hours',
}

const talkTime = {
  metaData: Object.assign(identifiers, formatting, keys, calculation),
  calculationConfig: calculation,
}

export { talkTime }
